import { FC } from 'react';
import { useSignedUrl } from 'src/lib/query';
import { twMerge } from 'tailwind-merge';

interface SignatureItemProps {
  signature: string | null;
  size?: 'default' | 'lg';
}

export const SignatureItem: FC<SignatureItemProps> = ({ signature, size = 'default' }) => {
  const autoGeneratePrefix = 'auto_generate:';

  const isAutoGenerate = signature?.startsWith(autoGeneratePrefix);

  const { data: signatureData } = useSignedUrl(signature, { enabled: !!signature && !isAutoGenerate });

  const sizeClasses = {
    default: 'h-10 w-10 text-16 border-2',
    lg: 'h-36 w-36 text-60 border-6',
  };

  if (!signature) return <></>;
  if (isAutoGenerate) {
    const name = signature.slice(autoGeneratePrefix.length).trim();
    const firstThree = name.slice(0, 3);
    const firstTwo = firstThree.slice(0, 2);
    const third = firstThree.slice(2, 3);
    return (
      <div
        style={{ fontFamily: 'ChosunGs', color: '#7B1B0E', borderColor: '#7B1B0E' }}
        className={twMerge(
          'mx-auto my-1 flex items-center justify-center whitespace-pre-line rounded-full font-extrabold leading-none',
          sizeClasses[size],
        )}
      >{`${firstTwo}\n${third}인`}</div>
    );
  }
  if (size === 'lg') {
    return (
      <div
        className="z-10 h-full w-full overflow-hidden rounded bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url("${signature}")` }}
      />
    );
  }
  return <img src={signatureData} alt="" crossOrigin="anonymous" className="m-auto w-[50px]" />;
};
